import { createSlice } from "@reduxjs/toolkit";
import { EditBarcodeProps } from "../types";

const initialState: EditBarcodeProps = {
  editBarcodeDtl: null,
};

const editBarcodeDtlReducer = createSlice({
  name: "barcodeProduct",
  initialState: initialState,
  reducers: {
    setEditBarcodeDtl(state, action) {
      return {
        ...state,
        editBarcodeDtl: action.payload,
      };
    },
  },
});

export default editBarcodeDtlReducer.reducer;

export const { setEditBarcodeDtl } = editBarcodeDtlReducer.actions;
